import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import { hsCodeValidationSchema } from '../../validation/hsCode';
import HSCodeForm from '~/components/hsCodeForm/hsCodeForm';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getHSCodeQuery = gql`
  query hsCode($id: Int!) {
    hsCode(id: $id) {
      id
      name
      description
      products {
        id
        name
      }
    }
  }
`;

export const updateHSCodesutation = gql`
  mutation updateHSCode($id: Int!, $name: String!, $description: String) {
    updateHSCode(id: $id, name: $name, description: $description) {
      id
      name
      breweryId
      description
    }
  }
`;

export class HSCodeEdit extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Same silly update Apollo issue I keep running into
      return false;
    }

    return true;
  }

  render() {
    const { onCompleted, id, history } = this.props;

    return (
      <Query query={getHSCodeQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { hsCode } = data;
          return (
            <div className="content">
              <Mutation mutation={updateHSCodesutation}>
                {(updateIngredient, { error }) => (
                  <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={hsCode}
                    validationSchema={hsCodeValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        await updateIngredient({
                          variables: {
                            id,
                            ...values
                          }
                        });
                        history.push(`/settings/hscodes/${id}?updated=true`);
                      } catch (err) {
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={HSCodeForm}
                  />
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(HSCodeEdit));



// WEBPACK FOOTER //
// ./src/containers/hsCodeEdit/hsCodeEdit.jsx